// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentActionStyles$ReactHooksTemplate = require("./ImportEnrichmentActionStyles.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");

function ImportEnrichmentFieldPicker(props) {
  var onTargetSelect = props.onTargetSelect;
  var __targetField = props.targetField;
  var __targetKind = props.targetKind;
  var placeholder = props.placeholder;
  var onChange = props.onChange;
  var value = props.value;
  var fieldOptions = props.fieldOptions;
  var targetKind = __targetKind !== undefined ? __targetKind : "column";
  var targetField = __targetField !== undefined ? __targetField : "";
  var renderReadableOptions = function (fields) {
    return Belt_Array.map(fields, (function (field) {
                  return JsxRuntime.jsx("option", {
                              children: field.label,
                              value: field.path
                            }, field.path);
                }));
  };
  if (props.mode === "ReadablePath") {
    var customerFields = ImportEnrichmentFieldOptions$ReactHooksTemplate.sortByLabel(fieldOptions.fields);
    var contextFields = ImportEnrichmentFieldOptions$ReactHooksTemplate.sortByLabel(fieldOptions.contextFields);
    var allFields = Belt_Array.concat(customerFields, contextFields);
    var selectValue = Belt_Array.some(allFields, (function (field) {
            return field.path === value;
          })) ? value : "";
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("select", {
                        children: [
                          JsxRuntime.jsx("option", {
                                children: placeholder,
                                value: ""
                              }),
                          customerFields.length !== 0 ? JsxRuntime.jsx("optgroup", {
                                  children: renderReadableOptions(customerFields),
                                  label: "Customer data"
                                }) : null,
                          contextFields.length !== 0 ? JsxRuntime.jsx("optgroup", {
                                  children: renderReadableOptions(contextFields),
                                  label: "Context"
                                }) : null
                        ],
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                        disabled: allFields.length === 0,
                        value: selectValue,
                        onChange: (function (e) {
                            if (onChange !== undefined) {
                              return Curry._1(onChange, e.target.value);
                            }
                            
                          })
                      }),
                  allFields.length === 0 ? JsxRuntime.jsx("p", {
                          children: "Add customer_details Data Fields under General Settings to populate this list.",
                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                        }) : null
                ]
              });
  }
  var writable = ImportEnrichmentFieldOptions$ReactHooksTemplate.flatWritableOptions(fieldOptions);
  var currentValue = targetKind + "|" + targetField;
  var selectValue$1 = Belt_Array.some(writable, (function (field) {
          return ImportEnrichmentFieldOptions$ReactHooksTemplate.encodeTargetValue(field) === currentValue;
        })) ? currentValue : "";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("select", {
                      children: [
                        JsxRuntime.jsx("option", {
                              children: placeholder,
                              value: ""
                            }),
                        Belt_Array.map(writable, (function (field) {
                                return JsxRuntime.jsx("option", {
                                            children: field.label,
                                            value: ImportEnrichmentFieldOptions$ReactHooksTemplate.encodeTargetValue(field)
                                          }, ImportEnrichmentFieldOptions$ReactHooksTemplate.encodeTargetValue(field));
                              }))
                      ],
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                      disabled: writable.length === 0,
                      value: selectValue$1,
                      onChange: (function (e) {
                          var v = e.target.value;
                          if (onTargetSelect === undefined) {
                            return ;
                          }
                          if (v === "") {
                            return Curry._2(onTargetSelect, targetKind, "");
                          }
                          var parts = Js_string.split("|", v);
                          var match = Belt_Array.get(parts, 0);
                          var match$1 = Belt_Array.get(parts, 1);
                          if (match !== undefined && match$1 !== undefined) {
                            return Curry._2(onTargetSelect, match, match$1);
                          }
                          
                        })
                    }),
                writable.length === 0 ? JsxRuntime.jsx("p", {
                        children: "Add customer_details Data Fields under General Settings to choose an action target.",
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                      }) : null
              ]
            });
}

var make = ImportEnrichmentFieldPicker;

exports.make = make;
/* react/jsx-runtime Not a pure module */
